import axios from "axios";

export default async function getPostalCodeInfo(postalCode: string) {
	try {
		const response = await axios.get(`https://viacep.com.br/ws/${postalCode}/json/`);
		if (response.data) {
			return response.data;
		}
	} catch (error) {
		console.error(error);
	}
	return null;
}
